import { render } from "./ArchitectureTab.vue?vue&type=template&id=39718050&scoped=true"
import script from "./ArchitectureTab.vue?vue&type=script&lang=js"
export * from "./ArchitectureTab.vue?vue&type=script&lang=js"

import "./ArchitectureTab.vue?vue&type=style&index=0&id=39718050&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39718050"]])

export default __exports__